import e,{useState as A,forwardRef as V}from"react";import{forwardRef as v,createElement as G}from"react";var g=t=>t.replace(/([a-z0-9])([A-Z])/g,"$1-$2").toLowerCase(),I=(...t)=>t.filter((a,u,o)=>!!a&&o.indexOf(a)===u).join(" ");import{forwardRef as H,createElement as P}from"react";var w={xmlns:"http://www.w3.org/2000/svg",width:24,height:24,viewBox:"0 0 24 24",fill:"none",stroke:"currentColor",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"};var k=H(({color:t="currentColor",size:a=24,strokeWidth:u=2,absoluteStrokeWidth:o,className:d="",children:l,iconNode:f,...C},r)=>P("svg",{ref:r,...w,width:a,height:a,stroke:t,strokeWidth:o?Number(u)*24/Number(a):u,className:I("lucide",d),...C},[...f.map(([n,p])=>P(n,p)),...Array.isArray(l)?l:[l]]));var x=(t,a)=>{let u=v(({className:o,...d},l)=>G(k,{ref:l,iconNode:a,className:I(`lucide-${g(t)}`,o),...d}));return u.displayName=`${t}`,u};var i=x("EyeOff",[["path",{d:"M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",key:"ct8e1f"}],["path",{d:"M14.084 14.158a3 3 0 0 1-4.242-4.242",key:"151rxh"}],["path",{d:"M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",key:"13bj9a"}],["path",{d:"m2 2 20 20",key:"1ooewy"}]]);var c=x("Eye",[["path",{d:"M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",key:"1nclc0"}],["circle",{cx:"12",cy:"12",r:"3",key:"1v7zrd"}]]);var E=V(({label:t,error:a,helperText:u,startAdornment:o,endAdornment:d,size:l="medium",maxLength:f,showCharacterCount:C,disabled:r,readOnly:n,type:p="text",className:B,value:h,defaultValue:F,onChange:D,...s},M)=>{let[m,R]=A(!1),[T,q]=A(h||F||""),y=S=>{q(S.target.value),D?.(S)},b={small:"h-8 text-sm",medium:"h-10 text-base",large:"h-12 text-lg"},L=p==="password",U=L&&m?"text":p,O=String(T).length;return e.createElement("div",{className:"w-full","data-id":"element-31"},t&&e.createElement("label",{className:`block mb-1 text-sm font-medium ${r?"text-gray-400":"text-gray-700"}`,"data-id":"element-32"},t),e.createElement("div",{className:"relative","data-id":"element-33"},o&&e.createElement("div",{className:"absolute left-3 top-1/2 -translate-y-1/2 text-gray-500","data-id":"element-34"},o),e.createElement("input",{...s,ref:M,type:U,value:h,onChange:y,disabled:r,readOnly:n,maxLength:f,className:`
              w-full
              ${b[l]}
              px-3
              border
              rounded-md
              outline-none
              transition-colors
              ${o?"pl-10":""}
              ${d||L?"pr-10":""}
              ${a?"border-gray-900 bg-gray-50":"border-gray-300 hover:border-gray-400"}
              ${r?"bg-gray-100 text-gray-400 cursor-not-allowed":"bg-white"}
              ${n?"bg-gray-50 cursor-default":""}
              focus:border-gray-900
              focus:ring-1
              focus:ring-gray-900
              ${B||""}
            `,"aria-invalid":!!a,"aria-describedby":a?`${s.id}-error`:u?`${s.id}-helper`:void 0,"data-id":"element-35"}),(d||L)&&e.createElement("div",{className:"absolute right-3 top-1/2 -translate-y-1/2 text-gray-500","data-id":"element-36"},L?e.createElement("button",{type:"button",onClick:()=>R(!m),className:"p-1 hover:text-gray-700","aria-label":m?"Hide password":"Show password","data-id":"element-37"},m?e.createElement(i,{size:16,"data-id":"element-38"}):e.createElement(c,{size:16,"data-id":"element-39"})):d)),e.createElement("div",{className:"mt-1 flex justify-between","data-id":"element-40"},(a||u)&&e.createElement("span",{id:a?`${s.id}-error`:`${s.id}-helper`,className:`text-sm ${a?"text-gray-900":"text-gray-500"}`,"data-id":"element-41"},a||u),C&&f&&e.createElement("span",{className:"text-sm text-gray-500","data-id":"element-42"},O,"/",f)))});E.displayName="Input";export{E as Input};
/*! Bundled license information:

lucide-react/dist/esm/shared/src/utils.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/defaultAttributes.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/Icon.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/createLucideIcon.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/eye-off.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/eye.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/lucide-react.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)
*/
